import { RootState } from "../../store.types";
import { State } from "./report.types";

export const getCurrentState = (state: RootState): State => state.report;

export const isReportLoading = (state: RootState) =>
  getCurrentState(state).isReportLoading;

export const isDownloadReportLoading = (state: RootState) =>
  getCurrentState(state).isDownloadReportLoading;

export const getReportSuccess = (state: RootState) =>
  getCurrentState(state).reportSuccess;

export const getReportList = (state: RootState) =>
  getCurrentState(state).reportList;
